import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Brand } from "@/components/Brand";

export const AuthShell = ({ title, subtitle, children, backTo = "/", testId }) => (
  <div data-testid={testId} className="min-h-screen cofre-bg">
    <div className="mx-auto w-full max-w-xl px-5 py-8 sm:py-12">
      <div className="mb-8 flex items-center justify-between">
        <Brand />
        <Link
          to={backTo}
          data-testid="auth-back-link"
          className="inline-flex min-h-[48px] items-center gap-2 rounded-xl px-3 text-lg font-semibold text-emerald-800 hover:bg-emerald-50"
        >
          <ArrowLeft className="h-5 w-5" /> Voltar
        </Link>
      </div>
      <div className="fade-up rounded-3xl border-2 border-slate-200 bg-white p-6 sm:p-10 shadow-sm">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-emerald-950">{title}</h1>
        {subtitle && <p className="mt-3 text-lg text-slate-600 leading-relaxed">{subtitle}</p>}
        <div className="mt-8">{children}</div>
      </div>
    </div>
  </div>
);
